// extracted by mini-css-extract-plugin
export default {"strip":"sMgTD","root":"tS8HH","separatorHorizontal":"xC8+k","logo":"aWPeg","rightReserved":"_1Wlyu"};